module.exports = __webpack_public_path__ + "7cc7732d178e49affaade3f5d6baaac8.pdf";